/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import { Link as NavLink } from "rc-scroll-anim";
import { library } from "@fortawesome/fontawesome-svg-core";
// import { faHo, faCoffee } from "@fortawesome/free-regular-svg-icons";
import {
  faHome,
  faBars,
  faAngleDoubleUp,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faClipboardList,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Nav from "./nav";

import "../scss/style.scss";

library.add(
  faHome,
  faBars,
  faAngleDoubleUp,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faClipboardList,
  faCogs
);

const Layout = ({
  children,
  isHome = false,
  hasEquipment = true,
  hasSpecialProcess = true,
  hasMedia = true,
}) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Nav
          siteTitle={data.site.siteMetadata.title}
          isHome={isHome}
          hasEquipment={hasEquipment}
          hasSpecialProcess={hasSpecialProcess}
          hasMedia={hasMedia}
        />
        <main>{children}</main>
        <footer className="text-center">
          <div className="footer-below">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  Copyright &copy; 2020 Baker Hughes
                </div>
              </div>
            </div>
          </div>
        </footer>

        <div className="scroll-top hidden-lg-up">
          <NavLink
            component="a"
            className="btn btn-primary page-scroll"
            to="page-top"
          >
            <FontAwesomeIcon icon="angle-double-up" />
          </NavLink>
        </div>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
